import applicationRoutes from '../../../constants/applicationRoutes.ts';
import { RouteAuthenticationRequirement, RouteItem } from '@cks-internal/react-base';
import Layout from '../../../app/Layout.tsx';

//not rendered in the nav bar (no Text)
export const AccountManagementItems: RouteItem = {
  path: '/',
  layout: <Layout forceUnauthenticatedNav={true} />,
  authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
  subItems: [
    {
      authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
      path: applicationRoutes.account.resetPassword,
      async lazy() {
        const component = await import('../../../features/auth/ResetPassword.tsx');
        return { Component: component.ResetPasswordPage };
      }
    },
    {
      authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
      path: applicationRoutes.account.forgotPassword,
      async lazy() {
        const component = await import('../../../features/auth/ForgotPassword.tsx');
        return { Component: component.ForgotPasswordPage };
      }
    },
    {
      authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
      path: applicationRoutes.account.logout,
      async lazy() {
        const component = await import('../../../features/auth/Logout.tsx');
        return { Component: component.Logout };
      }
    }
  ]
};

export const AccessDeniedRouteItem: RouteItem = {
  path: applicationRoutes.account.accessDenied,
  authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
  layout: <Layout forceUnauthenticatedNav={true} />,
  async lazy() {
    const component = await import('../../../app/routes/FrontierAccessDenied.tsx');
    return { Component: component.FrontierAccessDenied };
  }
};
export const LoginRouteItem: RouteItem = {
  text: 'Login',
  path: applicationRoutes.account.login,
  authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
  layout: <Layout forceUnauthenticatedNav={true} />,
  async lazy() {
    const component = await import('../../../features/auth/Login.tsx');
    return { Component: component.LoginPage };
  }
};

export const LoginTwoFactorRouteItem: RouteItem = {
  path: applicationRoutes.account.twoFactorLogin,
  authenticationRequirement: RouteAuthenticationRequirement.Unauthenticated,
  layout: <Layout />,
  async lazy() {
    const component = await import('../../../features/auth/LoginTwoFactor.tsx');
    return { Component: component.LoginTwoFactor };
  }
};

export const MyAccountItem: RouteItem = {
  layout: <Layout forceUnauthenticatedNav={true} />,
  path: applicationRoutes.account.myProfile,
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [],

  subItems: [
    {
      text: 'Manage Account',
      path: applicationRoutes.account.myProfile,
      allowedRoles: [],
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      async lazy() {
        const component = await import('../../../features/auth/MyProfile.tsx');
        return { Component: component.MyProfile };
      }
    },
    {
      text: 'Logout',
      path: applicationRoutes.account.logout,
      allowedRoles: [],
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      async lazy() {
        const component = await import('../../../features/auth/Logout.tsx');
        return { Component: component.Logout };
      }
    }
  ]
};
